/**
 * @packageDocumentation
 * @module HackerAPI.Claim.Review
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import Base from "../../base/base";
import { parseDate } from "../../utils/utils";
/**
 * A data container for review related information with static methods for interfacing with hackerapi.com
 * @class
 * @extends { HackerAPI.Base }
 */
var Review = /** @class */ (function (_super) {
    __extends(Review, _super);
    /**
     * Instantiates a new instance of a review
     * @constructor
     * @param review
     */
    function Review(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, note = _b.note, reviewer_id = _b.reviewer_id, reviewerId = _b.reviewerId, reviewer_name = _b.reviewer_name, reviewerName = _b.reviewerName, history = _b.history, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * The review ID
         * @type { string }
         */
        _this.id = id;
        /**
         * A note describing the review
         * @type { string }
         */
        _this.note = note;
        /**
         * The user ID of the reviewer (I think?)
         * @type { number }
         */
        _this.reviewerId = reviewer_id || reviewerId;
        /**
         * The name of the reviewer
         * @type { string }
         */
        _this.reviewerName = reviewer_name || reviewerName;
        /**
         * The history of review (currently only ever returns an empty list)
         * @type { any[] }
         */
        _this.history = history || [];
        /**
         * When the review was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Fetches a review from hackerapi
     * @param claim
     * @param claim.id
     * @param review
     * @param review.id
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Review.fetch = function (_a, _b, token) {
        var claimId = _a.id;
        var reviewId = _b.id;
        return HackerAPIFetch({
            path: "/v2/claims/" + claimId + "/reviews/" + reviewId,
            method: "GET",
            token: token
        }).then(function (data) { return new Review(data); });
    };
    /**
     * Adds a new review to a claim
     * @param claim
     * @param claim.id
     * @param review
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Review.add = function (_a, review, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/claims/" + id + "/reviews",
            method: "POST",
            token: token,
            body: review.toHackerAPIFormat()
        }).then(function (data) { return new Review(data); });
    };
    /**
     * Updates a review to a claim
     * @param claim
     * @param claim.id
     * @param review
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Review.update = function (_a, review, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/claims/" + id + "/reviews/" + review.id,
            method: "PUT",
            token: token,
            body: review.toHackerAPIFormat()
        }).then(function (data) { return new Review(data); });
    };
    return Review;
}(Base));
export default Review;
//# sourceMappingURL=review.js.map